import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {usersList_template} from "../components/templates/usersList_template";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class users extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: usersList_template;
    protected pagination: pagination_template;

    protected getModuleName(){

        return "users";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        // create the users list
        this.elementsList = new usersList_template("list", this.viewModel, this);
        this.template = this.elementsList;

        //only show Add User button if CM or Admin
        let vnApp = this.getVnAppZone().app;
        let roles = vnApp.loggedUser.user.valnet_user.roles;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Users List");

        return [this.elementsList.build()];
    }


    fillPage() : void{

        this.getFormData();
    }

    protected getFormData() {

        let token: string;
        let action: string;


        let validateReq_url: string = '/api/users/references/';
        let validateReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(validateReq_url, validateReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdl.execute();

    }

    protected onGetFormDataReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                let userRoles = [];
                let brandsList = [];

                for (let role of responseParsed.roles) {
                    userRoles.push({id: role.id, name: role.name});
                }
                for (let brand of responseParsed.brands) {
                    brandsList.push({id: brand.id, name: brand.name});
                }

                obj.elementsList.roleFilter.setItems(userRoles);
                obj.elementsList.brandFilter.setItems(brandsList);
                obj.elementsList.isActiveFilter.setItems([
                    {id: 1, name: "Yes"},
                    {id: 0, name: "No"},
                ])

                obj.updateViewModelFromPath();
                obj.getSearchPresetsListData();
                //
                obj.filterList();
            });
        }
    }




    protected editUser(id){

        this.saveViewModule(this.getMemoryViewModel());
        page('/users/edit/'+id);
    }

    protected viewUserProfile(id){

        this.saveViewModule(this.getMemoryViewModel());
        page('/users/profile/'+id);
    }

    protected earningsUser(id){

        this.saveViewModule(this.getMemoryViewModel());
        page('/payment/earnings/'+id);
    }

    protected addUser(){

        this.saveViewModule(this.getMemoryViewModel());
        page('/users/add');
    }

    protected paginationOnPageClick(){

        this.filterList();
    }

    protected userListReorder(){

        this.filterList();
    }

    protected filterDropdownOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterMultipleSelectorOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected getMemoryViewModel(){
        let templateViewModel = this.elementsList.getTemplateViewModel();

        delete templateViewModel.user;

        return templateViewModel;
    }

    protected filterList(){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        let subViewModel = this.elementsList.getViewModelForRequest();

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/users';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.sendFilterCall(
            usrReq_url,
            subViewModel,
            this.onFilterRequestReturn, XMLHttpRequestHandler_requestType.GET,
            'users-list',this.elementsList.builtTemplate.children.namedItem("list-results")
        );

        // this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        // this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){


        return function(){
            obj.manageResponse(req, obj, function(){
                //console.log(this.XHRHdl.reqestStartTime());
                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
            });
        }
    }

    //
    // update the module list using the objects list
    protected updateList(responseParsed: any){

        // set users list
        let usersToSet = [];
        for (let item of responseParsed.paginatedResults.data) {

            let claimingTax = "";
            if (item.taxNumbers !== undefined && item.taxNumbers.length > 0){
                claimingTax = "YES";
            }
            usersToSet.push( {
                pictureUrl:  ((item.valnet_user.pictureUrl) ? item.valnet_user.pictureUrl : "/assets/images/default-user.png"),
                emakiProfile: '/users/profile/' + item.id,
                fullName: item.valnet_user.fullName,
                loginName: item.valnet_user.loginName,
                email: item.valnet_user.email,
                dateCreated : item.dateCreated.substring(0,10),
                dateUpdate : item.dateUpdated.substring(0,10),
                dateLastLogin : (item.lastLoginDate != null) ? item.lastLoginDate.substring(0,10) : null,
                fullNameEditedBy : item.lastEditedBy,
                id : item.id,
                claimingTax: claimingTax
            } )
        }

        this.elementsList.setUsers(usersToSet);
        const startRequestTime = this.XHRHdls["/api/users-users-list"].requestStartTime;
        let execTime = Math.round((new Date().getTime() - startRequestTime)/1000*100)/100;
        this.elementsList.setResultInfo(responseParsed.paginatedResults.totalCount, responseParsed.paginatedResults.totalPage,execTime );

        // update the paginator
        this.viewModel.list.pagination.itemCount(responseParsed.paginatedResults.totalCount);

        this.elementsList.setAddButtonShown(responseParsed.permissions.users_list.write);
    }


    protected getSearchPresetsListData(): void {

        if( "getSearchPresetsListData" in this.XHRHdls ){
            this.XHRHdls["getSearchPresetsListData"].cancelAndReset();
        }

        let subVM = JSON.parse(ko.toJSON(this.elementsList.getViewModelForRequest()));
        let url: string = '/api/search_preset/get/';
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(subVM)]);

        this.XHRHdls['getSearchPresetsListData']= new XMLHttpRequestHandler(url, params, this);

        this.XHRHdls['getSearchPresetsListData'].onReadyStateFunction = this.onGetSearchPresetsReturn;
        this.XHRHdls['getSearchPresetsListData'].execute();
    }

    protected onGetSearchPresetsReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.elementsList.setSearchPresets(response);
                obj.filterList();
            });
        }
    }

    protected saveSearchPreset(){

        if( "saveSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveSearchPreset"].cancelAndReset();
        }

        let url: string = '/api/search_preset/save';
        let params: Array<Array<string>> = [];

        let subVM = JSON.parse(ko.toJSON(this.elementsList.getViewModelForRequest()));

        params.push(["data", ko.toJSON(subVM)] );

        this.XHRHdls['saveSearchPreset'] = new XMLHttpRequestHandler(url,params, this);

        this.XHRHdls['saveSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveSearchPreset'].onReadyStateFunction = this.onPostSearchPresetTasks
        this.XHRHdls['saveSearchPreset'].execute();
    }

    private onPostSearchPresetTasks(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.elementsList.addCreatedPresetToList(response);
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Preset saved successfully.");
                obj.getVnAppZone().showNotificationToModule();
            });
        }
    }


    protected filterByUrl(){

        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterByPresets(filters){

        this.elementsList.setViewModelFromRequest(filters);
        this.filterList();
    }

    protected setDefaultStatusFilters(){
        this.elementsList.setDefaultFilters();
    }
}


// WEBPACK FOOTER //
// ./js/modules/users.ts